import Vue from 'vue';

class Auth {
    constructor() {
        this.token = Vue.prototype.$storage.get('token');
        this.oPerson = Vue.prototype.$storage.get('person');

        if (this.token) {
            Vue.prototype.$Api.setToken(this.token);

            this.getPerson();
        }
    }

    login(token) {
        Vue.prototype.$Api.setToken(token);

        this.token = token;
    }

    logout() {
        Vue.prototype.$storage.clear();

        this.token = null;
        this.oPerson = null;
    }

    check() {
        return !!this.token;
    }

    getPerson() {
        return new Promise((resolve, reject) => {
            Vue.prototype.$Api.call('base.getCurrentPerson')
                .then(({data}) => {
                    this.oPerson = data;

                    Vue.prototype.$storage.set('person', data);

                    resolve(data);
                })
                .catch(({data}) => {
                    reject(data);
                });
        });
    }

    checkPermission(arRoles, oPersona) {
        let accessAccepted = false;

        const person = (typeof oPersona === 'undefined') ? this.oPerson || null : oPersona;
        if (person) {
            arRoles.forEach(
                (sRole) => {
                    switch (sRole) {
                        case 'employee':
                            if (person.roles.includes('employee')) {
                                accessAccepted = true;
                            }
                            break;
                        case 'manager':
                            if (person.roles.includes('manager')) {
                                accessAccepted = true;
                            }
                            break;
                        case 'hr':
                            if (person.roles.includes('hr')) {
                                accessAccepted = true;
                            }
                            break;
                        case 'administrator':
                            if (person.roles.includes('administrator')) {
                                accessAccepted = true;
                            }
                            break;
                        default:
                            accessAccepted = false;
                    }
                },
            );
        }

        return accessAccepted;
    }

    isEmployee(oPerson) {
        return this.checkPermission(['employee'], oPerson);
    }

    isManager(oPerson) {
        return this.checkPermission(['manager'], oPerson);
    }

    isHr(oPerson) {
        return this.checkPermission(['hr'], oPerson);
    }

    isAdmin(oPerson) {
        return this.checkPermission(['administrator'], oPerson);
    }
}

export default Auth;
